// Letters with stacked combining marks (accents written as separate characters,
// as in "Zalgo" text). Browsers draw a letter and its marks with one font, and the
// bundled Inter lacks most marks, so they showed up as "NO GLYPH" boxes. Such letters
// are wrapped in `.combining-marks`, which uses a font that has the letter and its
// marks (see styles/fonts/inter.scss).

const MARK_BLOCKS = [
  [0x0300, 0x036f], // combining diacritical marks
  [0x1ab0, 0x1aff], // extended
  [0x1dc0, 0x1dff], // supplement
  [0x20d0, 0x20ff], // marks for symbols
  [0xfe20, 0xfe2f], // half marks
];

// Marks the Inter subsets contain, a letter with only these stays in Inter.
const INTER_MARKS = [0x0300, 0x0301, 0x0303, 0x0304, 0x0308, 0x0309, 0x0323];

const isMark = (cp) => MARK_BLOCKS.some(([from, to]) => cp >= from && cp <= to);

/**
 * Wraps letters with marks Inter lacks in a span. Expects HTML-escaped text
 * without tags, so it runs before emojify.
 * @param {string} html escaped text
 * @returns {string}
 */
export const wrapCombiningMarks = (html) => {
  const chars = Array.from(html);
  let result = "";
  let i = 0;

  while (i < chars.length) {
    const base = chars[i];
    let end = i + 1;
    let needsFont = false;

    while (end < chars.length && isMark(chars[end].codePointAt(0))) {
      needsFont = needsFont || !INTER_MARKS.includes(chars[end].codePointAt(0));
      end += 1;
    }

    const cluster = chars.slice(i, end).join("");
    // A mark after an entity (";") or at the start has no letter to attach to.
    result += needsFont && base !== ";" && !isMark(base.codePointAt(0)) ? `<span class="combining-marks">${cluster}</span>` : cluster;
    i = end;
  }

  return result;
};
